module.exports = __webpack_public_path__ + "media/images/front/not-logged-in-lp-renew/img_webinar_jssr_1_01-8d06ec3f23cbe386fa22cafe424c5bfe.png";